import { render } from "./Footer.vue?vue&type=template&id=69c5c7da&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=69c5c7da&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c5c7da"]])

export default __exports__